/** Does nothing. Use as an explicit default for optional callbacks. */
export const noop = (): void => undefined;
